import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useData } from '../../context/DataContext';
import Header from './Header';
import Footer from './Footer';
import InventoryView from './Views/InventoryView';
import IncidentsTab from '../Incidents/IncidentsTab';
import ReportsTab from '../Reports/ReportsTab';
import ExcelImporter from '../Search/ExcelImporter';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSearch, FiAlertCircle, FiFileText } = FiIcons;

/**
 * Dashboard principal - Versión de Producción Estable.
 * SE HAN ELIMINADO TODAS LAS ANIMACIONES (framer-motion).
 * Renderizado condicional puro para evitar errores de reconciliación.
 */
const Dashboard = () => {
  const { user, loading: authLoading } = useAuth();
  const { isLoading: dataLoading, inventoryData } = useData();
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState('search');
  const [isImporterOpen, setIsImporterOpen] = useState(false);

  useEffect(() => {
    if (!authLoading && !user) {
      navigate('/login');
    }
  }, [user, authLoading, navigate]);

  if (authLoading || dataLoading) {
    return (
      <div className="fixed inset-0 bg-white flex flex-col items-center justify-center z-50">
        <div className="w-10 h-10 border-4 border-gray-200 border-t-red-600 rounded-full animate-spin mb-4"></div>
        <p className="text-gray-500 font-medium animate-pulse">Cargando sistema...</p>
      </div>
    );
  }

  const navItems = [
    { id: 'search', label: 'Buscar', icon: FiSearch },
    { id: 'incidents', label: 'Incidencias', icon: FiAlertCircle },
    { id: 'reports', label: 'Informes', icon: FiFileText },
  ];

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col overflow-x-hidden">
      {/* Header */}
      <Header 
        onOpenImporter={() => setIsImporterOpen(true)} 
        hasData={inventoryData.length > 0} 
      />

      {/* Tabs Superiores */}
      <nav className="bg-white border-b border-gray-200 sticky top-[61px] z-30">
        <div className="max-w-4xl mx-auto flex">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => setActiveTab(item.id)}
              className={`flex-1 flex flex-col items-center py-3 relative transition-colors ${
                activeTab === item.id ? 'text-red-600' : 'text-gray-400 hover:text-gray-600'
              }`}
            >
              <SafeIcon icon={item.icon} className="text-lg mb-1" />
              <span className="text-[10px] font-bold uppercase tracking-wider">{item.label}</span>
              {activeTab === item.id && (
                <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-red-600" />
              )}
            </button>
          ))}
        </div>
      </nav>

      {/* Contenido Principal */}
      <main className="flex-1 w-full max-w-4xl mx-auto p-4 sm:p-6">
        {activeTab === 'search' && <InventoryView onOpenImporter={() => setIsImporterOpen(true)} />}
        {activeTab === 'incidents' && <IncidentsTab />}
        {activeTab === 'reports' && <ReportsTab />}
      </main>

      {/* Modal Importador (Sin animaciones) */}
      {isImporterOpen && (
        <ExcelImporter onClose={() => setIsImporterOpen(false)} />
      )}

      {/* Footer simple */}
      <Footer />
    </div>
  );
};

export default Dashboard;